import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import {
  refundSuccess,
  refundFailure,
} from "../../Action/monumpay/refundAction";
import { REFUND } from "../../Action/actionTypes";
import { notifyPromise } from "../../../Utils/Helper";

function* refundRequest(action) {
  try {
    const { data } = yield notifyPromise(
      API.post("/refund", action?.payload?.payload),
      "Initiating Refund"
    );
    if (action?.payload?.callback) {
      yield call(action.payload.callback, data);
    }

    if (data?.meta?.code === 200) {
      yield put(refundSuccess(data?.data));
    } else {
      yield put(refundFailure());
    }
  } catch (error) {
    yield put(refundFailure());
    if (action?.payload?.callback) {
      yield call(action.payload.callback, {});
    }
  }
}

export function* watchRefundAPI() {
  yield takeEvery(REFUND, refundRequest);
}

export default function* rootSaga() {
  yield all([watchRefundAPI()]);
}
